import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Select } from 'chakra-react-select';
import { Box } from '@chakra-ui/react';
import { useGetDialPlans } from '../queries';
import { dropDownFormStyle } from 'components/forms/new/formStyles';
import { customSelectStyles } from '../constants';

const DialPlansDropdown = ({ currentId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { darkMode } = useSelector((state) => state.settings);
    const { data: dialPlans, isLoading } = useGetDialPlans();

    const handleChange = (option) => {
        if (option?.value) {
            navigate(`/dial-plans/${option.value}${location.search}`);
        }
    };

    if (isLoading) return <span>Loading...</span>;

    const options =
        dialPlans?.map((dp) => ({
            label: dp.name,
            value: dp.id,
        })) || [];

    const selectedOption = options.find((opt) => opt.value === currentId);

    const customStyles = dropDownFormStyle(darkMode);

    return (
        <Box minWidth="250px" display="inline-block">
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                menuPortalTarget={document.body}
                useBasicStyles
                chakraStyles={customSelectStyles(customStyles, darkMode)}
                isSearchable
                placeholder="Select Dial Plan"
                classNamePrefix="chakra-react-select"
            />
        </Box>
    );
};

export default DialPlansDropdown;
